export const tableStyles = {
  '& .table-container': {
    borderRadius: '8px',
    '& .table-cell': {
      whiteSpace: 'normal',
    },
    '& .table-body': {
      '& .table-cell': {
        color: ({ palette }) => palette.text.dark,
      },
    },
  },
};

export const emptyMessageCellStyles = {
  padding: 0,
};
